import { SignalFollowActionButton } from "features/signals/SignalFollow/SignalFollowActionButton";
import React from "react";
import { FollowSignalData } from "@shared/types";
import { TooltipPlacement } from "antd/es/tooltip";
import styled from "styled-components";
import { FollowSignalType } from "@shared/features/signals/common/types";
import Button from "common/Buttons/Button";
import { useSetAutoTrading } from "features/signals/common/hooks.tsx";

interface SignalFollowActionsProps {
  signal: FollowSignalData;
  isDrawer: boolean;
}

const SignalFollowActions = ({
  signal,
  isDrawer,
}: SignalFollowActionsProps) => {
  const { onSetAutoTradingClick } = useSetAutoTrading(signal);
  const tooltipPlacement: TooltipPlacement = isDrawer
    ? "bottomLeft"
    : "bottomRight";
  const buttonProps = {
    signal,
    isDrawer,
    tooltipPlacement,
  };

  const renderButtons = () => (
    <>
      {isDrawer && (
        <Button onClick={onSetAutoTradingClick}>Set Auto-Trading</Button>
      )}
      {signal.is_open ? (
        <>
          <SignalFollowActionButton
            followType={FollowSignalType.FOLLOW}
            {...buttonProps}
          />
          <SignalFollowActionButton
            followType={FollowSignalType.UPDATE}
            {...buttonProps}
          />
        </>
      ) : (
        <SignalFollowActionButton
          followType={FollowSignalType.CANCEL}
          {...buttonProps}
        />
      )}
    </>
  );

  if (isDrawer) return renderButtons();

  return (
    <ActionWrapper $isOpenSignal={signal.is_open}>
      {renderButtons()}
    </ActionWrapper>
  );
};

export default React.memo(SignalFollowActions);

const ActionWrapper = styled.div<{
  $isOpenSignal: boolean;
}>`
  display: flex;
  justify-content: ${(p) => (p.$isOpenSignal ? "flex-start" : "center")};
  column-gap: 12px;
`;
